import React, { useState } from "react";
import { useAuth } from "../context/authContext";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "./Alert";
import logo from "../assets/Logo.png";
import Back from "../assets/Back.png";
import { updateProfile } from "firebase/auth";
import { auth } from "../firebase";

export function Register() {
  const {
    signup,
    GuardarEnLocal,
    Estado,
    sincronizarUsuarioYDispositivo,
  } = useAuth();

  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [nombre, setNombre] = useState("");
  const [error, setError] = useState("");

  const handleChange = ({ target: { name, value } }) => {
    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNombre = (e) => {
    const nuevoNombre = e.target.value;

    setNombre(nuevoNombre);

    localStorage.setItem(
      "nombre",
      JSON.stringify(nuevoNombre)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // 1. Crear usuario en Firebase Auth
      const userCredential = await signup(
        user.email,
        user.password
      );

      const uid = userCredential.user.uid;

      // 2. Guardar nombre en Firebase Auth
      await updateProfile(userCredential.user, {
        displayName: nombre,
      });

      console.log(
        "✅ Nombre guardado en Firebase Auth Register:",
        nombre
      );

      // 3. Recargar usuario para obtener displayName actualizado
      await auth.currentUser.reload();

      console.log(
        "✅ Nombre tras reload:",
        auth.currentUser.displayName
      );

      // 4. Sincronizar usuario y dispositivo
      await sincronizarUsuarioYDispositivo(
        uid,
        auth.currentUser.displayName,
        user.email
      );

      // 5. Guardar datos locales y estado
      await GuardarEnLocal(uid);
      await Estado(uid);

      localStorage.setItem("PuntosSesion", 0);
      localStorage.setItem("PuntosTotales", 0);

      // 6. Ir a selección de clase
      navigate("/Comprobacion");
    } catch (error) {
      console.error("❌ Error en registro:", error);
      setError(error.message);
    }
  };

  return (
    <div
      className="relative min-h-screen w-full overflow-y-auto bg-black text-white"
      style={{
        backgroundImage: `url(${Back})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Oscurecer imagen para mejorar legibilidad */}
      <div className="absolute inset-0 bg-black/65" />

      {/* Degradado de marca */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/35 to-black/95" />

      {/* Luces decorativas */}
      <div className="pointer-events-none absolute -left-24 top-20 h-72 w-72 rounded-full bg-lime-400/10 blur-3xl" />

      <div className="pointer-events-none absolute -right-24 bottom-10 h-72 w-72 rounded-full bg-green-500/10 blur-3xl" />

      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-4 py-8 lg:px-8">
        <div className="grid w-full items-center gap-8 lg:grid-cols-2 lg:gap-14">

          {/* MENSAJE DE VENTA */}
          <section className="text-center lg:text-left">
            <img
              src={logo}
              alt="CoachCycling"
              className="mx-auto w-36 lg:mx-0 lg:w-44"
            />

            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-lime-400/30 bg-lime-400/10 px-4 py-2 text-xs font-extrabold uppercase tracking-[0.18em] text-lime-300">
              <span className="h-2 w-2 rounded-full bg-lime-400 animate-pulse" />
              Acceso gratuito
            </div>

            <h1 className="mt-5 text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
              Empieza a
              <span className="block text-lime-400">
                pedalear gratis
              </span>
            </h1>

            <p className="mx-auto mt-5 max-w-lg text-base leading-7 text-gray-300 lg:mx-0 lg:text-lg">
              Convierte tu móvil en tu compañero de
              entrenamiento. Controla tus RPM, sigue tu
              progreso y forma parte de la comunidad.
            </p>

            {/* Beneficios */}
            <div className="mt-7 grid grid-cols-3 gap-2 sm:gap-3">
              <div className="rounded-2xl border border-white/10 bg-black/35 p-3 text-center backdrop-blur-md">
                <div className="text-2xl">🚴</div>

                <p className="mt-2 text-xs font-bold text-white">
                  Modo libre
                </p>

                <p className="mt-1 text-[10px] text-gray-400">
                  Entrena gratis
                </p>
              </div>

              <div className="rounded-2xl border border-white/10 bg-black/35 p-3 text-center backdrop-blur-md">
                <div className="text-2xl">📊</div>

                <p className="mt-2 text-xs font-bold text-white">
                  Tu progreso
                </p>

                <p className="mt-1 text-[10px] text-gray-400">
                  RPM y métricas
                </p>
              </div>

              <div className="rounded-2xl border border-white/10 bg-black/35 p-3 text-center backdrop-blur-md">
                <div className="text-2xl">🏆</div>

                <p className="mt-2 text-xs font-bold text-white">
                  Rankings
                </p>

                <p className="mt-1 text-[10px] text-gray-400">
                  Suma puntos
                </p>
              </div>
            </div>
          </section>

          {/* FORMULARIO */}
          <section className="mx-auto w-full max-w-md">
            <div className="rounded-[28px] border border-white/15 bg-black/65 p-5 shadow-2xl backdrop-blur-xl sm:p-7">

              <div className="mb-6">
                <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-lime-400">
                  Únete ahora
                </p>

                <h2 className="mt-2 text-2xl font-black text-white">
                  Crea tu cuenta gratis
                </h2>

                <p className="mt-2 text-sm leading-6 text-gray-400">
                  Solo necesitas unos segundos para empezar.
                </p>
              </div>

              {error && (
                <div className="mb-5">
                  <Alert message={error} />
                </div>
              )}

              <form
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                {/* Nombre */}
                <div>
                  <label
                    htmlFor="nombre"
                    className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-300"
                  >
                    Tu nombre
                  </label>

                  <input
                    id="nombre"
                    type="text"
                    name="nombre"
                    value={nombre}
                    placeholder="¿Cómo te llamas?"
                    onChange={handleNombre}
                    autoComplete="name"
                    required
                    className="
                      w-full
                      rounded-2xl
                      border
                      border-white/10
                      bg-white/10
                      px-4
                      py-3.5
                      text-white
                      placeholder-gray-500
                      outline-none
                      transition
                      focus:border-lime-400/70
                      focus:bg-white/15
                      focus:ring-2
                      focus:ring-lime-400/20
                    "
                  />
                </div>

                {/* Email */}
                <div>
                  <label
                    htmlFor="email"
                    className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-300"
                  >
                    Correo electrónico
                  </label>

                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={user.email}
                    placeholder="tuemail@gmail.com"
                    onChange={handleChange}
                    autoComplete="email"
                    required
                    className="
                      w-full
                      rounded-2xl
                      border
                      border-white/10
                      bg-white/10
                      px-4
                      py-3.5
                      text-white
                      placeholder-gray-500
                      outline-none
                      transition
                      focus:border-lime-400/70
                      focus:bg-white/15
                      focus:ring-2
                      focus:ring-lime-400/20
                    "
                  />
                </div>

                {/* Contraseña */}
                <div>
                  <label
                    htmlFor="password"
                    className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-300"
                  >
                    Contraseña
                  </label>

                  <input
                    id="password"
                    type="password"
                    name="password"
                    value={user.password}
                    placeholder="Mínimo 6 caracteres"
                    onChange={handleChange}
                    autoComplete="new-password"
                    minLength={6}
                    required
                    className="
                      w-full
                      rounded-2xl
                      border
                      border-white/10
                      bg-white/10
                      px-4
                      py-3.5
                      text-white
                      placeholder-gray-500
                      outline-none
                      transition
                      focus:border-lime-400/70
                      focus:bg-white/15
                      focus:ring-2
                      focus:ring-lime-400/20
                    "
                  />

                  <p className="mt-2 text-xs text-gray-500">
                    Utiliza al menos 6 caracteres.
                  </p>
                </div>

                {/* CTA */}
                <button
                  type="submit"
                  className="
                    w-full
                    rounded-2xl
                    bg-gradient-to-r
                    from-lime-400
                    to-green-500
                    px-5
                    py-4
                    text-sm
                    font-black
                    uppercase
                    tracking-wide
                    text-black
                    shadow-xl
                    shadow-lime-500/20
                    transition
                    hover:brightness-110
                    active:scale-[0.98]
                  "
                >
                  Crear mi cuenta gratis
                </button>
              </form>

              {/* Confianza */}
              <div className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-gray-400">
                <span>✓ Sin tarjeta</span>
                <span>✓ Sin permanencia</span>
                <span>✓ Acceso inmediato</span>
              </div>

              {/* Login */}
              <div className="mt-6 border-t border-white/10 pt-5 text-center">
                <p className="text-sm text-gray-400">
                  ¿Ya formas parte de CoachCycling?
                </p>

                <Link
                  to="/login"
                  className="mt-2 inline-flex items-center justify-center font-bold text-lime-400 transition hover:text-lime-300"
                >
                  Inicia sesión
                  <span className="ml-2">→</span>
                </Link>
              </div>
            </div>

            <p className="mt-5 text-center text-xs text-gray-500">
              Empieza hoy. Tu primera pedalada está a unos
              segundos.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Register;